import CashierConfig from './cashier_config.vue'

export default {
    path: 'cashierConfig',
    component: CashierConfig
}
